'use strict';

angular.module('substoreApp.controllers')
    .controller('logoutController', ['$rootScope', '$scope', '$window', '$compile', '$routeParams', 'uiservice', 'sessionData', 'webtrekk',
        function ($rootScope, $scope, $window, $compile, $routeParams, uiservice, sessionData, webtrekk) {

            $scope.breadcrumb.init("logout");

            if (sessionData && sessionData.sessionId)
                sessionData.promise.then(function () {
                    if (!(sessionData.fault && sessionData.fault.code === "EXPIRED_SESSION"))
                        uiservice.deleteSession({sessionId: sessionData.sessionId, redirectTo: $routeParams.redirectTo},
                            function success(response) {
                                if (response.data.logoutURL) {
                                    // call logout URL in an iframe (we should wait for finish but we can't)
                                    angular.element(document.querySelector('#logout_iframe_container')).append($compile('<iframe src="' + response.data.logoutURL + '" width="1" height="1" />')({}));
                                }

                                if (response.data.partnerLogoutURL) {
                                    // call partner's logout URL in an iframe (we should wait for finish but we can't)
                                    angular.element(document.querySelector('#partner_logout_iframe_container')).append($compile('<iframe src="' + response.data.partnerLogoutURL + '" width="1" height="1" />')({}));
                                }

                                webtrekk.track('logout', {}).promise.then(function() {
                                    sessionData.deleteSessionData();
                                    if (response.data.logoutRedirectURL) {
                                        $window.location.href = response.data.logoutRedirectURL;
                                    }
                                });
                            },
                            $scope.throwServiceResponseFault
                        );
                });

       }
    ]);
